import { defineMessages } from 'react-intl';
import TermsPrivacy from '../../components/_Site/US/TermsPrivacy';
import TermsClubskp from '../../components/_Site/US/TermsClubskp';
import TermsAdditional from '../../components/_Site/US/TermsAdditional';

const messages = defineMessages({
  emailTerms: {
    id: 'us.emailTerms',
    defaultMessage: 'Henkel Terms of Use & Privacy Policy',
    description: 'us.emailTerms',
  },
  emailAdditionalTerms: {
    id: 'us.emailAdditionalTerms',
    defaultMessage: 'MYSKP Additional Terms of Use & Privacy Supplement',
    description: 'us.emailAdditionalTerms',
  },
  emailPrintcenterTerms: {
    id: 'us.emailPrintcenterTerms',
    defaultMessage: 'PrintCenter Terms of Use & Privacy Policy',
    description: 'us.emailPrintcenterTerms',
  },

  english: {
    id: 'us.english',
    defaultMessage: 'English',
    description: 'us.english',
  },

  shippingStandard: {
    id: 'us.shippingStandard',
    defaultMessage:
      'Standard Delivery (5 to 7 business days to most delivery locations in Canada) ',
    description: 'us.shippingStandard',
  },
  shippingDownload: {
    id: 'us.shippingDownload',
    defaultMessage: 'Digital Download',
    description: 'us.shippingDownload',
  },

  generalTerms: {
    id: 'us.generalTerms',
    defaultMessage: 'Terms of Use and Privacy Policy',
    description: 'us.generalTerms',
  },
  additionalTerms: {
    id: 'us.additionalTerms',
    defaultMessage: 'MYSKP Additional Terms of Use and Privacy Supplement',
    description: 'us.additionalTerms',
  },
  printCenterTerms: {
    id: 'us.printCenterTerms',
    defaultMessage: 'Clubskp Terms',
    description: 'us.printCenterTerms',
  },

  footerTrending: {
    id: 'us.footerTrending',
    defaultMessage: 'Trending',
    description: 'us.footerTrending',
  },
  footerEducation: {
    id: 'us.footerEducation',
    defaultMessage: 'Education',
    description: 'us.footerEducation',
  },
  footerProducts: {
    id: 'us.footerProducts',
    defaultMessage: 'Products',
    description: 'us.footerProducts',
  },
  footerMobileApps: {
    id: 'us.footerMobileApps',
    defaultMessage: 'Mobile Apps',
    description: 'us.footerMobileApps',
  },
  footerHelp: {
    id: 'us.footerHelp',
    defaultMessage: 'Help',
    description: 'us.footerHelp',
  },

  footerLatestInnovations: {
    id: 'us.footerLatestInnovations',
    defaultMessage: 'Latest Innovations',
    description: 'us.footerLatestInnovations',
  },
  footerEssentialLooks: {
    id: 'us.footerEssentialLooks',
    defaultMessage: 'Essential Looks',
    description: 'us.footerEssentialLooks',
  },
  // footerASKBrouchure: {
  //   id: 'us.footerASKBrouchure',
  //   defaultMessage: 'ASK Brouchure',
  //   description: 'us.footerASKBrouchure',
  // },
  footerEAcademy: {
    id: 'us.footerEAcademy',
    defaultMessage: 'eAcademy',
    description: 'us.footerEAcademy',
  },
  footerSeminars: {
    id: 'us.footerSeminars',
    defaultMessage: 'Seminars',
    description: 'us.footerSeminars',
  },
  footerHairColor: {
    id: 'us.footerHairColor',
    defaultMessage: 'Hair Color',
    description: 'us.footerHairColor',
  },
  footerHairCare: {
    id: 'us.footerHairCare',
    defaultMessage: 'Hair Care',
    description: 'us.footerHairCare',
  },
  footerHairStyling: {
    id: 'us.footerHairStyling',
    defaultMessage: 'Hair Styling',
    description: 'us.footerHairStyling',
  },
  footerHouseOfColor: {
    id: 'us.footerHouseOfColor',
    defaultMessage: 'House of Color',
    description: 'us.footerHouseOfColor',
  },
  footerHairExpert: {
    id: 'us.footerHairExpert',
    defaultMessage: 'Hair Expert',
    description: 'us.footerHairExpert',
  },
  footerASKAcademy: {
    id: 'us.footerASKAcademy',
    defaultMessage: 'ASK Academy',
    description: 'us.footerASKAcademy',
  },
  footerFaq: {
    id: 'us.footerFaq',
    defaultMessage: 'FAQ',
    description: 'us.footerFaq',
  },
  footerSupport: {
    id: 'us.footerSupport',
    defaultMessage: 'Support',
    description: 'us.footerSupport',
  },
  footerContact: {
    id: 'us.footerContact',
    defaultMessage: 'Contact',
    description: 'us.footerContact',
  },

  hairdressingSchool: {
    id: 'salondb.edit.hairdressingSchool',
    defaultMessage: 'Hairdressing School',
    description: 'salondb.edit.hairdressingSchool',
  },
  homeSalon: {
    id: 'salondb.edit.homeSalon',
    defaultMessage: 'Home Salon',
    description: 'salondb.edit.homeSalon',
  },
  retailOutlet: {
    id: 'salondb.edit.retailOutlet',
    defaultMessage: 'Retail Outlet',
    description: 'salondb.edit.retailOutlet',
  },
  distributorStore: {
    id: 'salondb.edit.distributorStore',
    defaultMessage: 'Distributor Store',
    description: 'salondb.edit.distributorStore',
  },
  vipSalon: {
    id: 'salondb.edit.vipSalon',
    defaultMessage: 'VIP Salon',
    description: 'salondb.edit.vipSalon',
  },
  traditionalSalon: {
    id: 'salondb.edit.traditionalSalon',
    defaultMessage: 'Traditional Salon',
    description: 'salondb.edit.traditionalSalon',
  },
});

export default {
  id: 'us',
  suffix: 'us',
  email: {
    defaultFrom: 'notifications@myskp.com',
    defaultReplyTo: ['orders-us@myskp.com'],
  },
  orderCc: ['orders-us@myskp.com'],
  printCenterCc: ['printcenter-us@myskp.com'],
  userSignupBcc: ['signups-us@myskp.com'],
  educationNotificationEmail: ['erica@myskp.com'],
  label: 'United States',
  company:
    'Schwarzkopf Professional, a division of Henkel USA Corporation, Inc',
  companyShort: 'Schwarzkopf Professional',
  emailFooterLinks: [
    // do not prepend host name
    {
      label: 'Henkel Terms of Use & Privacy Policy',
      href: '/us/#terms',
    },
    {
      label: 'MYSKP Additional Terms of Use & Privacy Supplement',
      href: '/us/#additional-terms',
    },
    {
      label: 'PrintCenter Terms of Use & Privacy Policy',
      href: '/us/#printcenter-terms',
    },
  ],
  flag: 'icon-flag--usa',
  locales: {
    'en-US': {
      label: 'English',
    },
    // 'es-US': {
    //   label: 'Spanish',
    // },
  },
  localesIntl(intl) {
    return {
      'en-US': {
        label: intl.formatMessage(messages.english),
      },
    };
  },
  countries: [
    { label: 'United States', value: 'US', threeChar: 'USA', default: true },
  ],
  social: {
    facebook: 'https://www.facebook.com/SchwarzkopfProfessionalUSA',
    instagram: 'https://www.instagram.com/schwarzkopfusa/',
    twitter: 'https://twitter.com/SchwarzkopfUSA',
    pinterest: 'https://www.pinterest.com/schwarzkopfpro/',
    youtube: 'https://www.youtube.com/user/Apassionforhair',
  },
  baseCurrency: 'USD',
  shippingOptions: {
    'flatrate-standard': {
      label: 'Standard Delivery',
      amount: 0,
    },
    'digital-download': {
      label: 'Digital Download',
      amount: 0,
    },
  },
  shippingPrintCenter: {
    amount: 1200,
  },
  currencies: [
    {
      code: 'USD',
      label: 'USD',
    },
    {
      code: 'POINTS',
      label: 'Points',
    },
  ],
  units: {
    distance: {
      label: 'Mile',
      abbrev: 'mi.',
    },
  },
  contact: {
    address: {
      str1: '600 Corporate Pointe, Suite 400',
      city: 'Culver City',
      state: 'CA',
      postal: '90230',
      country: 'USA',
    },
    phone: '310-568-5400',
    fax: '310-641-4601',
    email: 'clubskp@myskp.com',
    website: 'mySKP.com',
    support: 'https://myskp-usa.zendesk.com/hc/en-us',
  },
  loyalty: {
    tz: 'America/Los_Angeles',
    rollingExpiry: [13, 'months'], // passed into moment.subtract(...rollingExpiry)
    // DEPRECATED
    pointsExpireMoment: {
      month: 3, // jan = 0, dec = 11
      date: 1,
      startOf: 'day',
      tz: 'America/Los_Angeles',
      offset: {
        startOf: ['year'],
      },
    },
  },
  taxRates: {
    US: {
      CA: 0.0925,
    },
  },
  terms(intl) {
    return {
      // generalTerms is a required field
      generalTerms: {
        label: intl.formatMessage(messages.generalTerms),
        component: TermsPrivacy,
        props: [],
      },
      additionalTerms: {
        label: intl.formatMessage(messages.additionalTerms),
        component: TermsAdditional,
        props: [],
      },
      printCenterTerms: {
        label: intl.formatMessage(messages.printCenterTerms),
        component: TermsClubskp,
        props: [],
      },
    };
  },
  salonCategories(intl) {
    return [
      {
        value: '',
        label: '',
      },
      {
        value: 'Hairdressing School',
        label: intl.formatMessage(messages.hairdressingSchool),
      },
      {
        value: 'Home Salon',
        label: intl.formatMessage(messages.homeSalon),
      },
      {
        value: 'Retail Outlet',
        label: intl.formatMessage(messages.retailOutlet),
      },
      {
        value: 'Distributor Store',
        label: intl.formatMessage(messages.distributorStore),
      },
      {
        value: 'VIP Salon',
        label: intl.formatMessage(messages.vipSalon),
      },
      {
        value: 'Traditional Salon',
        label: intl.formatMessage(messages.traditionalSalon),
      },
    ];
  },
  footer(intl) {
    return [
      {
        label: intl.formatMessage(messages.footerTrending),
        links: [
          {
            label: intl.formatMessage(messages.footerLatestInnovations),
            to:
              'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/products/latest-innovations.html',
          },
          {
            label: intl.formatMessage(messages.footerEssentialLooks),
            to:
              'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/trends/essential-looks.html',
          },
        ],
      },
      {
        label: intl.formatMessage(messages.footerEducation),
        links: [
          // {
          //   label: intl.formatMessage(messages.footerASKBrouchure),
          //   to:
          //     'https://myskp-printcenter.nyc3.digitaloceanspaces.com/ask/ASK_Academy_Brochure_USA.pdf',
          // },
          {
            label: intl.formatMessage(messages.footerEAcademy),
            to:
              'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/education/ask-education-eacademy.html',
          },
          {
            label: intl.formatMessage(messages.footerSeminars),
            to:
              'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/education/seminars.html',
          },
        ],
      },
      {
        label: intl.formatMessage(messages.footerProducts),
        links: [
          {
            label: intl.formatMessage(messages.footerHairColor),
            to:
              'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/products/color.html',
          },
          {
            label: intl.formatMessage(messages.footerHairCare),
            to:
              'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/products/care.html',
          },
          {
            label: intl.formatMessage(messages.footerHairStyling),
            to:
              'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/products/styling.html',
          },
        ],
      },
      {
        label: intl.formatMessage(messages.footerMobileApps),
        links: [
          {
            label: intl.formatMessage(messages.footerHouseOfColor),
            to:
              'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/products/color/house-of-color.html',
          },
          {
            label: intl.formatMessage(messages.footerEssentialLooks),
            to:
              'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/trends/el-app-and-e-mag.html',
          },
          {
            label: intl.formatMessage(messages.footerHairExpert),
            to:
              'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/products/care/hair-expert-app.html',
          },
          {
            label: intl.formatMessage(messages.footerASKAcademy),
            to:
              'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/education/your-academy.html',
          },
        ],
      },
      {
        label: intl.formatMessage(messages.footerHelp),
        links: [
          {
            label: intl.formatMessage(messages.footerFaq),
            to: 'https://myskp-usa.zendesk.com/hc/en-us',
          },
          {
            label: intl.formatMessage(messages.footerSupport),
            to: 'https://myskp-usa.zendesk.com/hc/en-us/requests/new',
          },
          {
            label: intl.formatMessage(messages.footerContact),
            to: 'https://myskp-usa.zendesk.com/hc/en-us/requests/new',
          },
        ],
      },
    ];
  },
};



// WEBPACK FOOTER //
// ./src/configs/sites/us.js